var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow_drop_down_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_drop_down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.604 11.604L6.643 8.642a.424.424 0 01-.092-.133A.364.364 0 016.896 8h6.208c.112 0 .203.037.272.113a.376.376 0 01.103.262c0 .014-.041.103-.123.266l-2.96 2.963a.555.555 0 01-.792 0z",
    fill: "#fff"
  }))));
}
export default SvgArrowDropDown;